import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import parse from 'html-react-parser';
import Box from '@mui/material/Box';

const BlockchainHeader = (props: any) => {
    const {header, body1, body2, bannerImage, subheading, body} = props;
    return (
        <Box>
            <MUITypography variant="h5" component="h2" className="web3-content-header">
                {header}
            </MUITypography>
            {subheading && <MUITypography className="blockchain-main-header">{subheading ? parse(subheading) : ''}</MUITypography>}
            {bannerImage && (
                <Box className="verticalMargin24">
                    <DisplayImage
                        src={bannerImage}
                        alt={header}
                        priority={false}
                        style={{width: '100%', height: 'auto', display: 'block'}}
                    />
                </Box>
            )}

            {body1 && <MUITypography className="blockchain-main-header">{body1 ? parse(body1) : ''}</MUITypography>}
            {body2 && <MUITypography className="blockchain-main-header">{body2}</MUITypography>}
            {body &&
                body?.map((item: any, index: number) => (
                    <MUITypography key={index + 1} className="blockchain-main-header">
                        {item.subheading ? parse(item.subheading) : ''}
                    </MUITypography>
                ))}
        </Box>
    );
};

export default memo(BlockchainHeader);
